/**
 * CSS ピクセルと 3D 空間の対応（純関数・GL 非依存）。
 *
 * 約束: z=0 の平面で 1 world unit = 1 CSS px。
 * これにより layout.fitPageBox() の結果をそのまま使え、ズーム・パンのクランプ式も
 * css2d と同一のものを流用できる。
 */
import { FOV_DEG, MAX_DPR } from './constants';

/**
 * z=0 の平面が host の CSS ピクセルと 1:1 になるカメラ距離。
 * 画角 fov の透視投影では、距離 d の平面の可視高さは 2·d·tan(fov/2) なので、
 * それが host の高さと一致する d を返す。
 */
export function cameraDistance(hostHeightPx: number, fovDeg: number = FOV_DEG): number {
  return hostHeightPx / 2 / Math.tan((fovDeg * Math.PI) / 360);
}

/** 描画倍率（devicePixelRatio を上限つきで丸める）。 */
export function pixelRatio(view: { devicePixelRatio?: number }): number {
  return Math.min(view.devicePixelRatio || 1, MAX_DPR);
}

/**
 * 拡大で生まれた余地の中にパンを収める（css2d の clampPan と同一の式）。
 * 本が視野の外へ飛ばないようにする。
 */
export function clampPan(
  pan: { x: number; y: number },
  bookWidth: number,
  bookHeight: number,
  zoom: number,
): { x: number; y: number } {
  const limit = {
    x: (bookWidth * (zoom - 1)) / 2,
    y: (bookHeight * (zoom - 1)) / 2,
  };
  return {
    x: Math.min(Math.max(pan.x, -limit.x), limit.x),
    y: Math.min(Math.max(pan.y, -limit.y), limit.y),
  };
}
